import React from 'react';
import WhyBookStyle from './style';
import { useSelector } from 'react-redux';
import { Col, Row, } from 'antd';
import { contentfulSelector } from 'src/redux/selectors/contentfulSelector';

const WhyBook: React.FC = () => {
    const contentfulData = useSelector(contentfulSelector);

    const items = [1, 3, 2, 4].map((id) => ({
        id,
        title: contentfulData[`whyBookWithYgtTitle${id}`],
        detail: contentfulData[`whyBookWithYourGolfTravel${id}`],
    }));

    return (
        <WhyBookStyle className="box-line">
            <div className="intro-title">Why book with Your Golf Travel?</div>
            <Row gutter={[16, 16]}>
                {items.map((item) => {
                    return (
                        <Col xs={24} md={6} key={item.id}>
                            <div className="box-why">
                                <div className="why-title">{item.title}</div>
                                <div className="why-detail">{item.detail}</div>
                            </div>
                        </Col>
                    );
                })}
            </Row>
        </WhyBookStyle>
    );
};

export default WhyBook;
